import { render, staticRenderFns } from "./emer-2.vue?vue&type=template&id=37db1bd4&scoped=true&"
import script from "./emer-2.vue?vue&type=script&lang=js&"
export * from "./emer-2.vue?vue&type=script&lang=js&"
import style0 from "./emer-2.vue?vue&type=style&index=0&id=37db1bd4&scoped=true&lang=css&"
import style1 from "./emer-2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db1bd4",
  null
  
)

export default component.exports